var label = {
    base: {
        font: "body",
        lineHeight: 4,
        cursor: "pointer",
        color: "black.100",
    },
    variants: {
        disabled: {
            true: {
                cursor: "default",
            },
        },
        size: {
            sm: {
                fontSize: "sm",
            },
            md: {
                fontSize: "md",
            },
            lg: {
                fontSize: "lg",
            },
        },
    },
    defaultProps: {
        size: "md",
    },
};

export { label };
//# sourceMappingURL=label.js.map
